const API_BASE_URL = process.env.REACT_APP_API_URL || '/yandex-kit/api';

class ApiClient {
    constructor() {
        this.baseUrl = API_BASE_URL;
    }

    /**
     * Получает initData из Telegram WebApp или из URL
     */
    getInitData() {
        // 1. Пробуем получить из Telegram WebApp
        if (window.Telegram?.WebApp?.initData) {
            return window.Telegram.WebApp.initData;
        }

        // 2. Пробуем получить из URL (для отладки в браузере)
        const urlParams = new URLSearchParams(window.location.search);
        // Проверяем наличие ключевых полей initData
        if (urlParams.has('query_id') || urlParams.has('user') || urlParams.has('hash')) {
            // Возвращаем строку запроса без '?'
            return window.location.search.slice(1);
        }

        return '';
    }

    /**
     * Выполняет запрос к API
     */
    async request(endpoint, options = {}) {
        const initData = this.getInitData();

        const headers = {
            'Content-Type': 'application/json',
            'x-init-data': initData,
            ...options.headers
        };

        const config = {
            ...options,
            headers
        };

        try {
            const response = await fetch(`${this.baseUrl}${endpoint}`, config);

            if (!response.ok) {
                const error = await response.json().catch(() => ({}));
                throw new Error(error.message || `HTTP Error: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('API Request Error:', error);
            throw error;
        }
    }

    /**
     * GET запрос
     */
    async get(endpoint) {
        return this.request(endpoint, {
            method: 'GET'
        });
    }

    /**
     * POST запрос
     */
    async post(endpoint, data) {
        return this.request(endpoint, {
            method: 'POST',
            body: JSON.stringify(data)
        });
    }

    /**
     * PUT запрос
     */
    async put(endpoint, data) {
        return this.request(endpoint, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }

    /**
     * DELETE запрос
     */
    async delete(endpoint) {
        return this.request(endpoint, {
            method: 'DELETE'
        });
    }

    // === API Methods ===

    /**
     * Проверка работоспособности сервера
     */
    async health() {
        return this.get('/health');
    }

    /**
     * Инициализация пользователя
     */
    async initUser() {
        return this.get('/auth/init');
    }

    /**
     * Отправляет письмо на сервер
     * @param {Object} letterData - Данные письма { field1, field2, field3 }
     * @returns {Promise<Object>}
     */
    async sendLetter(letterData) {
        return this.post('/letter', letterData);
    }

    /**
     * Отправляет событие аналитики
     * @param {string} eventName - Название события
     * @param {Object} metadata - Дополнительные данные
     * @returns {Promise<Object>}
     */
    async trackEvent(eventName, metadata = {}) {
        // Не блокируем UI ожиданием ответа аналитики, но логируем ошибки
        return this.post('/analytics/event', { event_name: eventName, metadata })
            .catch(err => console.error('Analytics Error:', err));
    }
}

const apiClient = new ApiClient();

export default apiClient;
